// extracted by mini-css-extract-plugin
module.exports = {"container":"stake_container__3YQmW","sidebar":"stake_sidebar__sAG-J","rightsection":"stake_rightsection__1OuPB"};